import { message } from 'antd';
import { api } from '../../../../../app/baseQuery';
import { HTTPResponse } from '../../../../../common/types/commonTypes';
import assyncWrapper from '../../../../../common/utils/assyncWrapper';
import {
  IClientIncentiveIncomeFormData,
  IClientView,
  IDeleteClientIncentive,
  IViewAccountIncentiveIncome,
} from '../../../AccountsTypes/AccountsTypes';
import { INCENTIVE_INCOME } from '../../../Api/Constants/constants';

export const client_IncentiveIncomeEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    // get client all incentive_income
    getClientIncentiveIncomes: build.query<
      HTTPResponse<IClientIncentiveIncomeFormData[]>,
      { trash: number; current: number; pageSize: number }
    >({
      query: (arg) => ({
        url: `/client/incentive/income?trash=${arg.trash}&page=${arg.current}&size=${arg.pageSize}`,
      }),
      providesTags: () => [{ type: 'Incentive_Income', id: INCENTIVE_INCOME }],
    }),

    // get client incentive income by id
    getViewClientIncentiveIncome: build.query<
      HTTPResponse<IClientView[]>,
      number
    >({
      query: (id) => ({ url: `/client/incentive/income/${id}` }),
      providesTags: () => [{ type: 'Incentive_Income', id: INCENTIVE_INCOME }],
    }),

    //create client incentive income
    createClientIncentiveIncome: build.mutation<
      HTTPResponse<number>,
      IClientIncentiveIncomeFormData
    >({
      query: (body) => ({
        url: `/client/incentive/income`,
        method: 'POST',
        body: body,
      }),
      onQueryStarted: async (arg, { queryFulfilled }) => {
        await assyncWrapper(async () => {
          await queryFulfilled;
          message.success('Incentive Income Added Successfully');
        });
      },
      invalidatesTags: () => [
        { type: 'Incentive_Income', id: INCENTIVE_INCOME },
      ],
    }),

    //edit client incentive income
    editClientIncentiveIncome: build.mutation<
      void,
      IClientIncentiveIncomeFormData
    >({
      query: (body) => ({
        url: `/client/incentive/income/${body.id}`,
        method: 'PATCH',
        body: body,
      }),
      onQueryStarted: async (arg, { queryFulfilled }) => {
        await assyncWrapper(async () => {
          await queryFulfilled;
          message.success('Incentive Income Edited Successfully');
        });
      },
      invalidatesTags: () => [
        { type: 'Incentive_Income', id: INCENTIVE_INCOME },
      ],
    }),

    //delete client incentive income
    deleteClientIncentiveIncome: build.mutation<void, IDeleteClientIncentive>({
      query: (body) => ({
        url: `/client/incentive/income/${body.id}`,
        method: 'DELETE',
        body: body,
      }),
      onQueryStarted: async (arg, { queryFulfilled }) => {
        await assyncWrapper(async () => {
          await queryFulfilled;
          message.success('Incentive Income Deleted Successfully');
        });
      },
      invalidatesTags: () => [
        { type: 'Incentive_Income', id: INCENTIVE_INCOME },
      ],
    }),
  }),
});

export const {
  useGetClientIncentiveIncomesQuery,
  useGetViewClientIncentiveIncomeQuery,
  useLazyGetViewClientIncentiveIncomeQuery,
  useCreateClientIncentiveIncomeMutation,
  useDeleteClientIncentiveIncomeMutation,
  useEditClientIncentiveIncomeMutation,
} = client_IncentiveIncomeEndpoints;
